import { AlertListItemType, AlertPricingType, AlertReviewType } from 'types/alerts';

import axios from '../config/axiosPrivate';

export const getAlerts = async (communityId: number): Promise<AlertListItemType[]> => {
  const response = await axios.get(`/alerts/communities/${communityId}`);
  return response.data;
};

export const getAlertDetails = async (alertId: number): Promise<AlertListItemType> => {
  const response = await axios.get(`/alerts/${alertId}/details`);
  return response.data;
};

export const getAlertPricing = async (alertId: number): Promise<AlertPricingType> => {
  const response = await axios.get(`/alerts/${alertId}/pricing`);
  return response.data;
};

export const getAlertReviews = async (alertId: number): Promise<AlertReviewType[]> => {
  const response = await axios.get(`/alerts/${alertId}/reviews`);
  return response.data;
};
